import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { pageContext } from 'ctm-util-functions';
import Immutable from 'immutable';
import { BrandLogo, ModalContainer, Text, SimpleFlexbox } from 'ctm-components';
import style from './link_toggle_modal.css';

/**
 * Displays a generic Modal Container with link
 * @param {Object} state The app state
 * @param {Object} props The component props
 * @returns {LinkToggleModal} A LinkToggleModal Component
 * @constructor
 */
class LinkToggleModal extends Component {

    constructor(props) {
        super(props);

        this.modalVisualProps = {
            contentVariant: 'padded',
            outerVariant: 'centered',
            containerVariant: 'centered',
            overlayVariant: 'dark'
        };
    }

    render = () => {
        const {
            stateProps: { product },
            contentProps: { providerToShowFor, title, text },
            openComponent
        } = this.props;

        const vertical = pageContext.getVertical();
        const brandLogoElementProps = { srcPath: `/evt/assets/images/logos/${vertical}` };

        if (providerToShowFor && product.getIn(['providerMeta', 'code']) !== providerToShowFor) {
            return null;
        }

        return (
            <ModalContainer stateProps={{ isOpen: false }} openComponent={openComponent} visualProps={this.modalVisualProps}>
                <SimpleFlexbox display="flex">
                    <BrandLogo stateProps={{ product }} elementProps={brandLogoElementProps} />
                    <h3 className={style.modal_title}>{title}</h3>
                </SimpleFlexbox>
                <Text innerHTML={text} />
            </ModalContainer>
        );
    };

}

LinkToggleModal.propTypes = {
    stateProps: PropTypes.shape({
        product: PropTypes.instanceOf(Immutable.Map)
    }),
    contentProps: PropTypes.shape({
        title: PropTypes.string,
        text: PropTypes.string,
        providerToShowFor: PropTypes.string
    }),
    openComponent: PropTypes.array
};

LinkToggleModal.defaultProps = {
    stateProps: {
        product: Immutable.Map()
    }
};

export { LinkToggleModal };
